// @generated by protoc-gen-es v1.10.0
// @generated from file fingertip/creator/form_response/v1/form_response.proto (package fingertip.creator.form_response.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { FormResponseItem } from "../../../common/type/v1/form_response_pb.js";
import { PageInfo } from "../../../common/type/v1/page_info_pb.js";
import { FormField } from "../../../common/type/v1/form_field_pb.js";
import { FormTemplate } from "../../../common/type/v1/form_template_pb.js";
import { Site } from "../../../common/type/v1/site_pb.js";
import { Page } from "../../../common/type/v1/page_pb.js";

/**
 * @generated from message fingertip.creator.form_response.v1.GetFormResponsesRequest
 */
export const GetFormResponsesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.form_response.v1.GetFormResponsesRequest",
  () => [
    { no: 1, name: "form_template_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.form_response.v1.GetFormResponsesResponse
 */
export const GetFormResponsesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.form_response.v1.GetFormResponsesResponse",
  () => [
    { no: 1, name: "form_responses", kind: "message", T: FormResponseItem, repeated: true },
    { no: 2, name: "total", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_info", kind: "message", T: PageInfo },
  ],
);

/**
 * @generated from message fingertip.creator.form_response.v1.GetFormResponseRequest
 */
export const GetFormResponseRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.form_response.v1.GetFormResponseRequest",
  () => [
    { no: 1, name: "form_template_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "form_response_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.form_response.v1.GetFormResponseResponse
 */
export const GetFormResponseResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.form_response.v1.GetFormResponseResponse",
  () => [
    { no: 1, name: "form_response", kind: "message", T: FormResponseItem },
  ],
);

/**
 * @generated from message fingertip.creator.form_response.v1.CreateFormResponsePublicRequest
 */
export const CreateFormResponsePublicRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.form_response.v1.CreateFormResponsePublicRequest",
  () => [
    { no: 1, name: "input", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 2, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "form_template_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "form_template_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "disable_notifications", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.form_response.v1.CreateFormResponsePublicResponse
 */
export const CreateFormResponsePublicResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.form_response.v1.CreateFormResponsePublicResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "form_response", kind: "message", T: FormResponseItem },
  ],
);

/**
 * @generated from message fingertip.creator.form_response.v1.DeleteFormResponseRequest
 */
export const DeleteFormResponseRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.form_response.v1.DeleteFormResponseRequest",
  () => [
    { no: 1, name: "form_response_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.form_response.v1.DeleteFormResponseResponse
 */
export const DeleteFormResponseResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.form_response.v1.DeleteFormResponseResponse",
  () => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message fingertip.creator.form_response.v1.SiteContactFormResponseItem
 */
export const SiteContactFormResponseItem = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.form_response.v1.SiteContactFormResponseItem",
  () => [
    { no: 1, name: "form_fields", kind: "message", T: FormField, repeated: true },
    { no: 2, name: "form_response", kind: "message", T: FormResponseItem },
    { no: 3, name: "form_template", kind: "message", T: FormTemplate },
  ],
);

/**
 * @generated from message fingertip.creator.form_response.v1.GetSiteContactFormResponsesRequest
 */
export const GetSiteContactFormResponsesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.form_response.v1.GetSiteContactFormResponsesRequest",
  () => [
    { no: 1, name: "site_contact_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message fingertip.creator.form_response.v1.GetSiteContactFormResponsesResponse
 */
export const GetSiteContactFormResponsesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.form_response.v1.GetSiteContactFormResponsesResponse",
  () => [
    { no: 1, name: "form_responses", kind: "message", T: SiteContactFormResponseItem, repeated: true },
    { no: 2, name: "total", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_info", kind: "message", T: PageInfo },
  ],
);

/**
 * @generated from message fingertip.creator.form_response.v1.GetCustomerFormResponsesItem
 */
export const GetCustomerFormResponsesItem = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.form_response.v1.GetCustomerFormResponsesItem",
  () => [
    { no: 1, name: "items", kind: "message", T: FormField, repeated: true },
    { no: 2, name: "form_response", kind: "message", T: FormResponseItem },
    { no: 3, name: "form_template", kind: "message", T: FormTemplate },
    { no: 4, name: "site", kind: "message", T: Site },
    { no: 5, name: "page", kind: "message", T: Page },
  ],
);

/**
 * @generated from message fingertip.creator.form_response.v1.GetCustomerFormResponsesRequest
 */
export const GetCustomerFormResponsesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.form_response.v1.GetCustomerFormResponsesRequest",
  () => [
    { no: 1, name: "cursor", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "search", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.form_response.v1.GetCustomerFormResponsesResponse
 */
export const GetCustomerFormResponsesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.form_response.v1.GetCustomerFormResponsesResponse",
  () => [
    { no: 1, name: "items", kind: "message", T: GetCustomerFormResponsesItem, repeated: true },
    { no: 2, name: "total", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_info", kind: "message", T: PageInfo },
  ],
);

/**
 * @generated from message fingertip.creator.form_response.v1.GetCustomerFormResponseRequest
 */
export const GetCustomerFormResponseRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.form_response.v1.GetCustomerFormResponseRequest",
  () => [
    { no: 1, name: "form_response_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.form_response.v1.GetCustomerFormResponseResponse
 */
export const GetCustomerFormResponseResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.form_response.v1.GetCustomerFormResponseResponse",
  () => [
    { no: 1, name: "form_fields", kind: "message", T: FormField, repeated: true },
    { no: 2, name: "form_response", kind: "message", T: FormResponseItem },
    { no: 3, name: "form_template", kind: "message", T: FormTemplate },
    { no: 4, name: "site", kind: "message", T: Site },
    { no: 5, name: "page", kind: "message", T: Page },
  ],
);

/**
 * @generated from message fingertip.creator.form_response.v1.ExportFormResponsesRequest
 */
export const ExportFormResponsesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.form_response.v1.ExportFormResponsesRequest",
  () => [
    { no: 1, name: "form_template_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "site_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message fingertip.creator.form_response.v1.ExportFormResponsesResponse
 */
export const ExportFormResponsesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.creator.form_response.v1.ExportFormResponsesResponse",
  () => [
    { no: 1, name: "csv_data", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

